<template>
  <div v-if="errorsList.length">
    <ul :class="$style.errorsList">
      <li
        v-for="error in errorsList"
        :key="error.errorType"
        :class="$style.errorText"
      >
        <i
          :class="[
            'jc-actions-alert',
            $style.error,
            $style.errorIcon
          ]"
        />
        <ScimTestError
          :class="$style.errorMessage"
          :errorObject="error"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import ScimTestError from 'client/applications/scim/ScimTestError.vue';

export default {
  name: 'ScimTestErrorsList',

  components: {
    ScimTestError,
  },

  props: {
    errorsList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style module>
@import './css/IdentityManagementCommon.css';

.errorsList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.errorIcon {
  margin-top: 3px;
}

.errorMessage {
  margin-left: 6px;
}

.errorText {
  display: flex;
  margin-bottom: 10px;
}

</style>
